import "./Portfolio.css"
import img1 from "../../assets/products/87b.png"
import img2 from "../../assets/products/ae7ee30c70f311b9e2cd5fc34360ed7d.png"
import img3 from "../../assets/products/7f59.png"
import img5 from "../../assets/products/unibid .png"
import img7 from "../../assets/products/500X500 135.jpg"
import img8 from "../../assets/products/500X500_sapost.jpg"
import img10 from "../../assets/products/sp.png"
import img11 from "../../assets/products/tcuk.png"
import img12 from "../../assets/products/biaboom.png"
import img13 from "../../assets/products/made in lorestan .png"
import {useState, useEffect} from "react";
import Loading from "../UI/Loading/Loading";

const Portfolio = () => {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        window.scrollTo(0, 0);
        const loadingTimeout = setTimeout(() => {
            setIsLoading(false);
        }, 2000);

        return () => {
            clearTimeout(loadingTimeout);
        };
    }, [])


    return (
        <>
            {isLoading && <Loading/>}
            <div className={"portfolio-container"}>
                <div className="portfolio-first">
                    <h1 className={"upToBottomAnimation"}>
                        Arnikup focuses on just a few
                        projects at any one time
                    </h1>
                </div>
                <div className="portfolio_product_cart">
                    <div className="product-card">
                        <div className="product-img">
                            <img src={img1} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                Vchange is an online fast and efficient platform to facilitate
                                cryptocurrency and currency exchange, obviating the need
                                to go through bureau de exchanges.
                                The system enables direct connection between those who
                                need a particular currency and those who can offer that
                                currency.
                            </p>
                        </div>
                    </div>

                    <div className="product-card">
                        <div className="product-img">
                            <img src={img2} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                Online intercity door-to-door parcel delivery application platform
                                which manages the interaction of cargo owners, haulage companies,
                                insurance and regulatory organizations in the most convenient and
                                cost efficient manner.
                            </p>
                        </div>
                    </div>

                    <div className="product-card">
                        <div className="product-img">
                            <img src={img3} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                The first online licenced Taxi service in Iran with over one million subscribers is a
                                startup company which has exceeded all expectations. Two years into its inception,
                                the company is already a household brand offering taxi rides at competitive prices
                                with passenger safety and comfort.
                            </p>
                        </div>
                    </div>
                    <div className="product-card">
                        <div className="product-img">
                            <img src={img5} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                Unibid is a leading start-up company operating within the auction sector. The
                                company offers various products at astonishing discounts while presenting a
                                fun and enjoyable experience. The company has seen exponential growth and
                                is expected to dominate the domestic market with eyes set upon international
                                expansion.
                            </p>
                        </div>
                    </div>
                    <div className="product-card">
                        <div className="product-img">
                            <img src={img7} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                135 laboratory is a white label system for the catering industry where
                                businesses can customise the system to their own particular brand,
                                operational procedures and financial arrangements.
                            </p>
                        </div>
                    </div>

                    <div className="product-card">
                        <div className="product-img">
                            <img src={img8} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                "Idea-based Sharif Company" was established in 2016, concentrating on software solutions
                                and startups. One of its prominent ventures is "Sapost," an electronic postbox service
                                launched in 2019 in partnership with the National Post Company of Iran, now accessible
                                to the public since September 2020.
                            </p>
                        </div>
                    </div>
                    <div className="product-card">
                        <div className="product-img">
                            <img src={img10} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                Silver Platta is a nation-wide B2C food delivery service in the UK. The first
                                of its kind to offer door-to-door Indian Cuisine
                                delivery service served on a platter with geolocation, intelligent routing
                                and AI capabilities.
                            </p>
                        </div>
                    </div>

                    <div className="product-card">
                        <div className="product-img">
                            <img src={img11} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                Travel Chef UK is a nationwide B2B frozen food distributor specialising in
                                cuisine from the Indian subcontinent. The company is committed to providing
                                excellent customer service and is currently makings strides in customer
                                acqusition and expansion.
                            </p>
                        </div>
                    </div>
                    <div className="product-card">
                        <div className="product-img">
                            <img src={img12} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                Iran boasts some of the world’s most pristine, unexplored, and natural landscape
                                attractions in the world, steeped in history and folklore. Biaboom offers a unique, rich
                                and truly
                                memorable rural and countryside experience by offering a select number of cottage
                                accommodations, local cuisine and handicraft to both international and domestic
                                tourists.
                            </p>
                        </div>
                    </div>
                    <div className="product-card">
                        <div className="product-img">
                            <img src={img13} alt=""/>
                        </div>
                        <div className="product-text">
                            <p>
                                Made in Lorestan is An E-commerce platform designed to promote
                                regional goods and services to be available across the globe.
                                The system is multilingual, multicurrency and multi occupancy
                                through a peer-to-peer architecture.
                            </p>
                        </div>
                        {/*<div className="product-cart">*/}
                        {/*    <a href="http://www.madeinlorestan.ir/" target={"_blank"} rel="noreferrer">*/}
                        {/*        <button type="submit">link</button>*/}
                        {/*    </a>*/}
                        {/*</div>*/}
                    </div>
                </div>


            </div>
        </>
    )
}
export default Portfolio;